import axios from "axios";
const axiosInstance = axios.create({
    withCredentials: true,
    headers: {
        common: {
            Accept: "application/json"
        }
    }
});
export default axiosInstance;
